<template>
  <b-tooltip position="is-left" :label="$t('tooltip.sections_add')">
    <div
      :class="this.$store.getters.sondage_results_count !== 0 ? 'isDisabled' : ''"
      @click="addSection()"
    >
      <img
        src="@/assets/img/icons/add-section-icon.png"
        :class="
          this.$store.getters.sondage_results_count !== 0
            ? 'icon'
            : 'icon-disabled'
        "
        alt="icon-add-section-icon"
      /><p style="color:black;"></p>
    </div>
  </b-tooltip>
</template>
<script>
export default {
  props: {
    entitledSurvey: {
      type: String,
      required: true
    }
  },
  methods: {
    addSection () {
      if (this.$store.getters.sondage_results_count === 0) {
        this.$store.commit('TEST_SAVE_SECTIONS_BUTTON')
        let indexSection = this.$store.state.question.sections.length
        this.$store.commit('ADD_SECTION', {
          indexSection: indexSection,
          entitledSurvey: this.entitledSurvey
        })
      }
    }
  }
}
</script>
<style scoped>
.icon {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  margin-left: 5px;
  margin-right: 5px;
  vertical-align: center;
  cursor: pointer;
}
.icon-disabled {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  margin-left: 5px;
  margin-right: 5px;
  vertical-align: center;
}
.isDisabled {
  pointer-events: none;
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/AddSectionQuestionButton.vue